import React, { Component } from 'react';
import './introSlider.scss';
import { Link } from 'react-scroll';
import Fade from 'react-reveal/Fade';
import i_scroll_down from '../../shared/assets/images/i_scroll_down.png';
import Payment from './payment';

class IntroSlider extends Component {
    constructor(props) {
        super(props);

    }
    
    render() {
        return (
            <div className="intro-slider">
                <div id="main">
                    <div>
                        {
                            /*
                            <Link to="howToUse" spy={true} smooth={true} offset={-90} duration={600}>
                                <Fade top>
                                    <img onClick={this.goDown}
                                        className="scroll-down-img" 
                                        src={i_scroll_down} 
                                        alt="i scroll down" />
                                </Fade>
                            </Link>
                            */
                        }
                        <div id="carouselControls" className="carousel slide" data-ride="carousel">
                            <div className="carousel-inner">
                                <div className="carousel-item active">
                                    <Payment onEaster2={this.props.onEaster2} />
                                </div>

                            </div>
                            <a className="carousel-control-prev" href="#carouselControls" role="button" data-slide="prev">
                                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                <span className="sr-only">Previous</span>
                            </a>
                            <a className="carousel-control-next" href="#carouselControls" role="button" data-slide="next">
                                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                <span className="sr-only">Next</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default IntroSlider;
